var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63833 18.3783H14.0317V16.628H4.63833V18.3783ZM4.63833 13.4191H14.0317V11.6687H4.63833V13.4191ZM1.75031 23.3375C1.28356 23.3375 0.875156 23.1625 0.525094 22.8124C0.175031 22.4623 0 22.0539 0 21.5872V1.75031C0 1.28356 0.175031 0.875156 0.525094 0.525094C0.875156 0.175031 1.28356 0 1.75031 0H12.2814L18.67 6.38864V21.5872C18.67 22.0539 18.495 22.4623 18.1449 22.8124C17.7948 23.1625 17.3864 23.3375 16.9197 23.3375H1.75031ZM11.4062 7.17628H16.9197L11.4062 1.75031V7.17628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextType);
export default __webpack_public_path__ + "static/media/textType.e9eb39ce216433f47509ae90ffbe487d.svg";
export { ForwardRef as ReactComponent };